// The rules for an answer put as readings (the find's `options`) — T453a (28 Oct 2026).
//
// ONE HOME for what the brain's ticks, the WhatsApp reply and the find each restated:
//
//  1. A PICK-SEVERAL NEEDS TWO READINGS (`OPTIONS_MIN`): one reading is no choice.
//  2. THE PICKED READINGS GO AS ONE LINE (`joinPicked`), in the order they were offered, so the
//     brain's Send and a typed "1 3" on WhatsApp ask the find the same words. Two or more are each
//     quoted, a quote inside one turned to an apostrophe, so "Voi, Lemonade" and "Wix" stays two
//     readings whatever a label holds and in any language (T453b, 1 Nov 2026; T453a quoted only on
//     an English comma or "and"); a label offered twice is joined once. One pick goes bare.
//  3. A TYPED NUMBER IS A READING'S POSITION (`readingsByNumber`), counted from one as the numbered
//     lines show them.
//
// Pure, importing nothing, so the brain's browser bundle takes it (`@vera/db/picked-options`). Kept
// out of `index.ts`, which re-exports `whatsapp-templates.ts` and with it `OPTIONS_MIN` already.

export const OPTIONS_MIN = 2;

/** The ticked readings, in the order they were offered, as one sentence's list: `"A", "B" and "C"`. */
export function joinPicked(options: readonly string[], ticked: ReadonlySet<string>): string {
  const picked = [...new Set(options.filter((label) => ticked.has(label)))];
  if (picked.length <= 1) return picked[0] ?? '';
  const shown = picked.map((label) => `"${label.replaceAll('"', "'")}"`);
  return `${shown.slice(0, -1).join(', ')} and ${shown[shown.length - 1]}`;
}

/** The labels at these 1-based positions, or null when there are none or any is not on the list. */
export function readingsByNumber(
  options: readonly string[],
  numbers: readonly number[],
): ReadonlySet<string> | null {
  if (numbers.length === 0) return null;
  if (numbers.some((n) => !Number.isInteger(n) || n < 1 || n > options.length)) return null;
  return new Set(numbers.map((n) => options[n - 1]!));
}
